var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 39);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  39: function _(e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    },
        o = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = n(r(1)),
        u = o(r(2)),
        l = r(3),
        c = l.colorPalettes.KineduPalette,
        s = u.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n  ", "\n  padding: 0px 10px;\n  height: 24px;\n  font-size: 12px;\n  font-weight: 500;\n\n  color: ", ";\n  background-color: ", ";\n  letter-spacing: 0;\n  text-align: center;\n  line-height: 8px;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
      var e = _ref.fullWidth;
      return e && "width: 100%;";
    }, function (_ref2) {
      var e = _ref2.textColor;
      return e;
    }, function (_ref3) {
      var e = _ref3.bgColor;
      return e;
    }, function (_ref4) {
      var e = _ref4.size;

      switch (e) {
        case "medium":
          return u.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        height: 24px;\n      "])));

        default:
          return u.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
      }
    }, function (_ref5) {
      var e = _ref5.type;

      switch (e) {
        case "success":
          return u.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        color: ", "\n        background-color: ", ";\n      "])), c.cognitiveDark50, c.cognitiveLight70);

        case "danger":
          return u.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        color: ", "\n        background-color: ", ";\n      "])), c.healthDark50, c.healthLight70);

        default:
          return u.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
      }
    });

    t.default = function (_ref6) {
      var _ref6$size = _ref6.size,
          e = _ref6$size === void 0 ? "medium" : _ref6$size,
          _ref6$type = _ref6.type,
          t = _ref6$type === void 0 ? "danger" : _ref6$type,
          _ref6$textColor = _ref6.textColor,
          r = _ref6$textColor === void 0 ? "#1C5C38" : _ref6$textColor,
          _ref6$bgColor = _ref6.bgColor,
          n = _ref6$bgColor === void 0 ? "#C8E2BA" : _ref6$bgColor,
          _ref6$fullWidth = _ref6.fullWidth,
          o = _ref6$fullWidth === void 0 ? !1 : _ref6$fullWidth,
          u = _ref6.children;
      return i.default.createElement(s, {
        textColor: r,
        bgColor: n,
        size: e,
        type: t,
        fullWidth: o
      }, u);
    };
  }
});